import angular from 'angular'

const ELEMENT_NODE = 1

export function getBlockNodes(nodes) {
  let node = nodes[0]
  const endNode = nodes[nodes.length - 1]
  let blockNodes

  for (let i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = angular.element(Array.prototype.slice.call(nodes, 0, i))
      }
      blockNodes.push(node)
    }
  }

  return blockNodes || nodes
}

export function domInsert(element, parentElement, afterElement) {
  if (afterElement) {
    const afterNode = extractElementNode(afterElement)
    if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
      afterElement = null
    }
  }
  if (afterElement) {
    afterElement.after(element)
  } else {
    parentElement.prepend(element)
  }
}

export function extractElementNode(element) {
  for (let i = 0; i < element.length; i++) {
    const elm = element[i]
    if (elm.nodeType === ELEMENT_NODE) {
      return elm
    }
  }
}
